import { render, staticRenderFns } from "./share-icon.vue?vue&type=template&id=740cc76c"
import script from "./share-icon.vue?vue&type=script&lang=js"
export * from "./share-icon.vue?vue&type=script&lang=js"
import style0 from "./share-icon.vue?vue&type=style&index=0&id=740cc76c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports